import React from 'react';
import orderBy from 'lodash/orderBy';
import uniq from 'lodash/uniq';
import PropTypes from 'prop-types';
import { withGoogleSheets } from 'react-db-google-sheets';
import { SectionTitle } from '../../components';
import { updateMetaInfo } from '../../utils';

const description = "Here's some latest news about Ather.";

const News = ({ db: { news } }) => {
  const years = uniq(news.filter(w => w.archived == 0).map(w => w.year))
    .sort()
    .reverse();
  const archiveYear = years[years.length - 1];

  let previousYear = null;

  return (
    <div className="news-area section padding-top padding-bottom">
      {updateMetaInfo(description)}
      <div className="container">
        <SectionTitle title="News" />
        <div className="news-wrapper">
          {years.map(year =>
            orderBy(
              news
                .filter(w => w.year === year && w.archived == 0)
                .map(w => ({ ...w, id: parseInt(w.id) })),
              ['id'],
              ['desc']
            ).map(s => {
              let date = `${s.month}/${s.year}`;

              if (date === previousYear) date = '';
              else previousYear = date;

              return (
                <div key={s.id} className="news mt-30">
                  <div className="news-summary">
                    <p className="news-year">{date}</p>
                  </div>
                  <div className="news-details">
                    <h2>
                      <p dangerouslySetInnerHTML={{ __html: s.title }} />
                    </h2>
                  </div>
                </div>
              );
            })
          )}
        </div>
        <p className="footnote">
          * awards from before {archiveYear} are omitted to maintain a shorter,
          more relevant list
        </p>
      </div>
    </div>
  );
};

News.propTypes = {
  db: PropTypes.shape({
    news: PropTypes.arrayOf(PropTypes.object)
  })
};

export default withGoogleSheets('news')(News);
